  <!-- 編輯狀態 -->
  <ng-template #Modal let-data let-ref="modalRef" >
    <form #ModalForm="ngForm">
      <nb-card class="staffInfoTemplate " [nbSpinner]="info.IsLoding">
        <nb-card-header style="display: flex; justify-content: space-between; align-items: center;">
          編輯狀態
        </nb-card-header>

        <nb-card-body>
          
          <div class="row">
            
            <!-- 販售門市價格設定 / -->
            <ng-container>
              <div class="row mx-0 col-sm-12  mt-2 justify-content-between">
                <label class="label col col-form-label text-nowrap">歷程紀錄-近三筆更新記錄</label>
                <button nbButton style="margin-left: auto;" (click)="ShowDataMo.onOpen()">查看全部</button>
                <div class="w-100 mt-2">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>操作人員</th>
                        <th>變更狀態</th>
                        <th>更新時間</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let status of statusHistory; let index = index">
                        <td style="vertical-align: middle; max-width: 150px; word-wrap: break-word;">
                          {{status.CreateBy}}
                        </td>
                        <td style="vertical-align: middle;">
                          {{status.statusName}}
                        </td>
                        <td style="vertical-align: middle;">
                          {{status.CreateDate}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="status-buttons">
            <div *ngFor="let status of statusList">
              <button nbButton
                      [disabled]="!status.CanClick"
                      (click)="onStatusClick(status.ID)">
                {{ status.statusName }}
              </button>
            </div>
          </div>
        </nb-card-body>
        <nb-card-footer>
          <div class="">
            <button nbButton (click)="onClose()">關閉</button>
          </div>
        </nb-card-footer>
      </nb-card>
    </form>
  </ng-template>
  
<!-- 彈窗 付款狀態-->
<app-show-data  #ShowDataMo_Tmp
*ngIf="ShowDataMo.isShow"
[EOSNo]="ShowDataMo.EOSNo"
[source]="ShowDataMo.source"
(emitClose)="ShowDataMo.onClose($event)">
</app-show-data>